import * as React from 'react';
import { observer } from 'mobx-react';
import { IClubControlAdditionalInfoPopupProps } from './IClubControlAdditionalInfoPopupProps';

@observer
export class ClubControlAdditionalInfoPopup extends React.Component<
  IClubControlAdditionalInfoPopupProps,
  undefined
> {
  render() {
    const iframeTitle = ''; //es-lint fix
    return (
      <div
        className="modal fade"
        id="showAdditionalInfoOnClub"
        /*tabindex="-1" */ role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <img
                src="Images/MultiGroupReport/Close_icon.svg"
                alt=""
                className="close-tiles-list-btn"
                data-dismiss="modal"
                aria-label="Close"
              />
              <iframe src={this.props.url} /*frameborder="0"*/ title={iframeTitle}></iframe>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
